import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=17181516"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports